import React from 'react';

const Services = () => (
  <section className="page">
    <h1>Services</h1>

    <h2>What You Get</h2>
    <p>
      Hestia Ledger’s here to cut through the mess of tracking your money. Whether you’re a solo hustler, 
      a small business owner, or just someone who likes data in order, I’ve built this to keep it simple 
      and systematic. No fancy jargon—just tools that work.
    </p>
    <p>
      The free version kicks off with an easy input form to log your transactions fast. It’s the bare 
      bones to get you going, no strings attached.
    </p>

    <h2>Full Version Perks</h2>
    <p>
      Step up to the full version, and you’re unlocking the good stuff: cloud storage to keep your data 
      safe and handy, tracking for recurring bills and income, and exports to Excel or PDF for when you 
      need to see the big picture. Plus, JSON imports/exports for total control, a clickable calendar 
      to manage entries, and that same dead-simple input form.
    </p>
    <p>
      It’s built for people like me—folks who’ve had enough financial chaos and want something that’s 
      theirs to run. Try it free, then grab the full deal if it clicks.
    </p>

    <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
  </section>
);

export default Services;